import {Base} from "@/api/Base"

export class LeaveSend extends Base {
    path = "leave/send"
}